import React, { CSSProperties } from "react";

import { spacing as spacingDefinitions } from "../styles";

type StackProps = React.HTMLAttributes<HTMLDivElement> & {
    orientation?: "vertical" | "horizontal";
    spacing?:
        | "none"
        | "tight"
        | "compact"
        | "cozy"
        | "comfortable"
        | "outerspace";
    fullHeight?: boolean;
    equalHeights?: boolean;
    verticalAlign?: "Top" | "Middle" | "Bottom";
    style?: CSSProperties;
};

export const Stack = ({
    orientation,
    spacing = "none",
    fullHeight,
    verticalAlign,
    style,
    ...props
}: StackProps) => {
    const stackStyle: CSSProperties = {
        display: "flex",
        flexDirection: orientation === "horizontal" ? "row" : "column",
        gap: spacingDefinitions[spacing]
    };

    // Handle fullHeight styles
    if (fullHeight) {
        stackStyle.height = "100%";
    }

    // Handle alignment based on orientation
    if (orientation === "horizontal") {
        switch (verticalAlign) {
            case "Top":
                stackStyle.alignItems = "start";
                break;
            case "Bottom":
                stackStyle.alignItems = "end";
                break;
            default:
                stackStyle.alignItems = "center";
        }
    } else {
        switch (verticalAlign) {
            case "Top":
                stackStyle.justifyContent = "start";
                break;
            case "Bottom":
                stackStyle.justifyContent = "end";
                break;
            case "Middle":
                stackStyle.justifyContent = "center";
                break;
            default:
                stackStyle.justifyContent = "space-between";
        }
    }

    return <div style={{ ...stackStyle, ...style }} {...props} />;
};
